import styled, { css } from "styled-components"
import { Variant } from "./index"
import { breakpoints } from "@config/theme"
import { rem } from "polished"

export const Container = styled.div<{ variant: Variant }>`
  width: 100%;
  position: relative;
  height: auto;
  background-color: ${(p) => p.theme.colors.softGrey};
  &::before {
    content: "";
    display: block;
  }

  ${(p) =>
    p.variant === "square" &&
    css`
      &::before {
        padding-top: 100%;
      }
    `}

  ${(p) =>
    p.variant === "wide" &&
    css`
      &::before {
        padding-top: 30%;
      }
      max-width: 1200px;
      margin: 0 auto;

      @media screen and (max-width: ${breakpoints.medium}) {
        &::before {
          padding-top: 40%;
        }
      }
      @media screen and (max-width: ${breakpoints.small}) {
        &::before {
          padding-top: 60%;
        }
      }
    `}
  ${(p) =>
    p.variant === "full-width" &&
    css`
      max-width: ${rem(1920)};
      margin: 0 auto;
      &::before {
        padding-top: 40%;
        @media screen and (min-width: ${breakpoints.small}) {
          padding-top: 50%;
        }

        @media screen and (min-width: ${breakpoints.large}) {
          padding-top: 25%;
        }
        @media screen and (min-width: ${breakpoints.xlarge}) {
          padding-top: 20%;
        }
      }
    `}
`

export const Image = styled.img`
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`
